module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/eye-icon-f27e4641951920be478abe63036bd259.svg";